<template>
  <vue-apex-charts
    class="istStackChart"
    ref="insightChartBar"
    :height="500"
    :options="chartOptionsBar"
    :series="series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";



export default {
  name: "InsightChartBar",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      chartOptionsBar: {
        chart: {
          type: "bar",
          toolbar:{
            show: false
          },
          sparkline:{
            enabled: true
          },
          stacked: true
        },
        grid:{
          show: true,
          yaxis:{
            lines:{
              show: false
            }
          },
        },
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
          textAnchor: 'middle',
          style: {
                colors: ['#fff']
              },
          formatter: function (val, opt) {
                return val
              },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },
        stroke: {
              width: 1,
              colors: ['#fff']
            },
        xaxis: {
          categories: ['단순 카테고리 탐색', '추천/순위/종류', '비교/후기', '기능', '용도/목적', '용량/크기', '공간/장소', '기타', '가격 및 구매처 탐색', '구매 후 관리', 'TOTAL'],
        },
        yaxis: {
          reversed: true,
          labels: {
            show: false
          }
        },
        plotOptions: {
          bar: {
                columnWidth: '99%',
                distributed: false,
                dataLabels: {
                  position: 'center',
                },
              }
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#1817E7',
            fontSize: '20px',
            fontFamily: "NanumBarunGothicB"
          }
        },
        // colors: ['#203864','#586A8B','#828FA8','#A1ABBE','#B8C0CE','#CAD0DA','#D7DCE3','#E1E5EA','#E8ECEF','#EEF1F3'],
        // colors: ['#182A4B','#223455','#2C3E5F','#364869','#405273','#4A5C7D','#546787','#5E7191','#687B9B','#7285A5'],
        colors: ['#142850','#23375F','#32466E','#41557D','#50648C','#5F739B','#6E82AA','#7D91B9','#8CA0C8','#9BAFD7'],
      },
      series: [
        {
          name: '',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],

      totFreq: 0
    };
  },
  props: {
    stackChartData: {
      type: Array,
      default: () => [],
    },
    stackChartCategory: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    stackChartData() {
      this.totFreq = 0
      const newData = []

      for (const data of this.stackChartData) {
        newData.push(data);

        for (const freq of data[1])
          this.totFreq += parseFloat(freq)
      }

      const newCategory = []
      for (const data of this.stackChartCategory) {
        newCategory.push(data);
      }

      this.setValues(newData, newCategory)
    },
  },
  methods:{
    setValues(newData, newCategory){
      this.series = []
      this.chartOptionsBar = {
        ...this.chartOptionsBar,
        ...{
              chart: {
                type: "bar",
                toolbar:{
                  show: false
                },
                sparkline:{
                  enabled: true
                },
                stacked: true,
                events: {
                  dataPointSelection: (event, chartContext, config) =>{
                    if(newData && newData.length > 0){
                      if(newData[config.seriesIndex][0][config.dataPointIndex] == '기타'){
                        var exceptList = []
                        for(const items of newData){
                          exceptList.push(items[0][config.dataPointIndex])
                        }
                        this.$parent.loadInsightDataBottomTableETC('cdjContent', exceptList, newCategory[config.dataPointIndex], '')
                      }else{
                        this.$parent.loadInsightDataBottomTable('cdjContent', newData[config.seriesIndex][0][config.dataPointIndex], '')
                      }
                    }
                  }
                }
              },
              xaxis:{
                categories: newCategory,
              },
              dataLabels: {
                enabled: true,
                textAnchor: 'middle',
                style: {
                      colors: ['#fff'],
                      fontFamily: "NanumBarunGothic !important",
                      fontSize: "11px",
                    },
                formatter: function (val, opt) {
                  if(newData && newData.length > 0){
                    if (newData[opt.seriesIndex][2][opt.dataPointIndex] == 0)
                      return [newData[opt.seriesIndex][0][opt.dataPointIndex], '＜ 0.1%']
                    else
                      return [newData[opt.seriesIndex][0][opt.dataPointIndex], newData[opt.seriesIndex][2][opt.dataPointIndex] + '%']
                  }else{
                    return ''
                  }
                    },
                offsetX: 0,
                offsetY: 16,
                dropShadow: {
                  enabled: false
                },
              },
              tooltip: {
                followCursor: true,
                x: {
                  show: true
                },
                y: {
                  formatter: function (val, opt) {
                    if(newData && newData.length > 0){
                      if (newData[opt.seriesIndex][2][opt.dataPointIndex] == 0) {
                        var rate = 0.0
                        
                        if (opt.w.globals.dom.baseEl.__vue__.totFreq > 0)
                          rate = parseFloat(newData[opt.seriesIndex][1][opt.dataPointIndex]) / opt.w.globals.dom.baseEl.__vue__.totFreq
                        
                        if (rate < 0.01)
                          return newData[opt.seriesIndex][0][opt.dataPointIndex] + ' : ' + Math.round(newData[opt.seriesIndex][1][opt.dataPointIndex]).toLocaleString() + '(＜ 0.01%)'
                        else
                          return newData[opt.seriesIndex][0][opt.dataPointIndex] + ' : ' + Math.round(newData[opt.seriesIndex][1][opt.dataPointIndex]).toLocaleString() + '(' + rate +'%)'
                      }
                      else
                        return newData[opt.seriesIndex][0][opt.dataPointIndex] + ' : ' + Math.round(newData[opt.seriesIndex][1][opt.dataPointIndex]).toLocaleString() + '(' + newData[opt.seriesIndex][2][opt.dataPointIndex] +'%)'
                    }else{
                      return ''
                    }
                  },
                  title: {
                    formatter: function () {
                      return ''
                    }
                  },
                },
                marker: {
                    show: false,
                },
              },             
            }
      }

      // this.chartOptionsBar.xaxis = {
      //     categories: newCategory,
      //   }
      // this.series = []
      var dataName = 0
      for(const item of newData) {
        dataName += 1
        this.series.push(
          {
            name: dataName,
            data: item[3],
            color: function(opt){
              var r = 0
              var g = 10
              var b = 40
              if(item[2][opt.dataPointIndex] > 50){
                r+=0
                g+=0
                b+=0
              }
              else if(item[2][opt.dataPointIndex] > 30){
                r+=20
                g+=20
                b+=20
              }else if(item[2][opt.dataPointIndex] > 10){
                r+=30
                g+=30
                b+=30
              }else if(item[2][opt.dataPointIndex] > 5){
                r+=40
                g+=40
                b+=40
              }else if(item[2][opt.dataPointIndex] > 3){
                r+=50
                g+=50
                b+=50
              }else if(item[2][opt.dataPointIndex] > 2){
                r+=60
                g+=60
                b+=60
              }else if(item[2][opt.dataPointIndex] > 1){
                r+=70
                g+=70
                b+=70
              }else if(item[2][opt.dataPointIndex] > 0.5){
                r+=80
                g+=80
                b+=80
              }else if(item[2][opt.dataPointIndex] > 0.25){
                r+=90
                g+=90
                b+=90
              }else if(item[2][opt.dataPointIndex] > 0.1){
                r+=110
                g+=110
                b+=110
              }else if(item[2][opt.dataPointIndex] > 0.07){
                r+=120
                g+=120
                b+=120
              }else if(item[2][opt.dataPointIndex] > 0.05){
                r+=130
                g+=130
                b+=130
              }else if(item[2][opt.dataPointIndex] > 0.04){
                r+=140
                g+=140
                b+=140
              }else if(item[2][opt.dataPointIndex] > 0.03){
                r+=150
                g+=150
                b+=150
              }else if(item[2][opt.dataPointIndex] > 0.02){
                r+=160
                g+=160
                b+=160
              }else if(item[2][opt.dataPointIndex] > 0.01){
                r+=170
                g+=170
                b+=170
              }
              else{
                r+=180
                g+=180
                b+=180
              }
              return 'RGB('+r+','+g+','+b+')'
            }
          }
        )
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";

.istStackChart .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {
  font-size: 12px !important;
  font-weight: 600;
}

.istStackChart .apexcharts-canvas .apexcharts-tooltip-text {
  font-family: NanumBarunGothic !important;
  font-weight: 400;
  font-size: 10px !important;
  filter: none;
}

</style>
